import {keyboardKeys} from './keyboardKeys'

export function isStringUndefinedOrEmpty(value?: string): boolean {
    return value === undefined || value === null || value.trim() === "";
}



export function convertDateTime(date: string, time?: string){
    let dateString: string;
    const isIsoFormat = /^\d{4}-\d{2}-\d{2}$/.test(date);
    const isIso8601Format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(date);
    const iso8601WithTimeZoneOffsetRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/.test(date);
    if (isIsoFormat || isIso8601Format || iso8601WithTimeZoneOffsetRegex) {
        dateString = date;
    } else {
        let delimiter = "/";
        if (date !== null && date !== undefined && date.includes("-")) {
            delimiter = "-";
        }
        dateString = date?.split(delimiter).reverse().join("-");
    }

    const datetimeString = time ? dateString + "T"+ time + ":00" : undefined;
    return new Date(datetimeString ?? dateString)
}

export function convertDateTimeToString(date: Date): string{
    return new Date(date.toString()).toString()
}


export function isEllipsisActive(container: HTMLElement, content: HTMLElement) {
    let parentContainer = container.parentNode as HTMLElement;
    let contentWidth = content.getBoundingClientRect().width;
    let containerWidth = container.getBoundingClientRect().width;
    let parentContainerWidth = parentContainer.getBoundingClientRect().width;
    if(contentWidth === 0){
        return false;
    }
    if(parentContainer.classList.contains('has-child-row-count')){
        return (parentContainerWidth < contentWidth);
    }
    return (containerWidth < contentWidth);
}

export function getKeyboardShortcut(key:keyboardKeys, modifier?:keyboardKeys){
    return modifier==null ? `window:keydown.${key}` : `window:keydown.${modifier}.${key}`;
}

export function DelayedExecutor(delay = 500): (executor: () => void) => void {
    let timer: any;
    return (executor: () => void) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            executor()
        }, delay)
    }
}
